import { createReducer } from '@mews/framework';
import { BODY_CELL_SELECTED, CELL_SELECTION_RESET } from '../actionTypes';

const INITIAL_STATE = {
    selectedCell: { columnIndex: null, rowIndex: null },
};

const matrixReducer = createReducer(INITIAL_STATE, {
    // @ts-expect-error $TSFixMeError: Parameter 'state' implicitly has an 'any' type.
    [BODY_CELL_SELECTED]: (state, { columnIndex, rowIndex }: $TSFixMe) => ({
        ...state,
        selectedCell: { columnIndex, rowIndex },
    }),
    [CELL_SELECTION_RESET]: (state: $TSFixMe) => ({
        ...state,
        selectedCell: { columnIndex: null, rowIndex: null },
    }),
});

export default matrixReducer;
